module.exports = "/_next/static/images/photoKyleClausen-61d2dccb0b0bf561dbf909affd9cdea9.webp";